import React, { useContext } from "react";
import { Grid, GridColumn, GridRow, LabeledText } from "sprint-common-web";

import { MuxSpecificationDashboardContext } from "../context/MuxSpecificationDashboardContext";
import { ensureIsManzanitaMuxSpecification } from "../MuxSpecificationDashboardItem";

export const ManzanitaMuxSpecificationTechnicalContent: React.VFC = () => {
    const { muxSpecificationDashboardItem } = useContext(MuxSpecificationDashboardContext);
    ensureIsManzanitaMuxSpecification(muxSpecificationDashboardItem);

    return (
        <Grid>
            <GridRow>
                <GridColumn lg={6}>
                    <LabeledText
                        label={"VBR "}
                        value={printNullableBooleanDisplayValue(muxSpecificationDashboardItem.vbr)}
                    />
                    <LabeledText
                        label={"Auto Descr AVC "}
                        value={printNullableBooleanDisplayValue(muxSpecificationDashboardItem.autoDescrAvc)}
                    />
                    <LabeledText label={"PMTPID "} value={muxSpecificationDashboardItem.pmtPid} />
                    <LabeledText label={"PCRPID"} value={muxSpecificationDashboardItem.pcrPid} />
                </GridColumn>
                <GridColumn lg={6}>
                    <LabeledText label={"Video PID"} value={muxSpecificationDashboardItem.videoPid} />
                    <LabeledText
                        label={"PES Align"}
                        value={printNullableBooleanDisplayValue(muxSpecificationDashboardItem.pesAlign)}
                    />
                    <LabeledText
                        label={"Max Decode Delay"}
                        value={muxSpecificationDashboardItem.maxDecodeDelay?.toString()}
                    />
                </GridColumn>
            </GridRow>
        </Grid>
    );
};

const printNullableBooleanDisplayValue = (value: boolean | undefined) => {
    return value !== undefined ? printBooleanValue(value) : "";
};

const printBooleanValue = (value: boolean) => (value ? "yes" : "no");
